import { render, staticRenderFns } from "./UserList.html?vue&type=template&id=128d593c&external"
import script from "./UserList.ts?vue&type=script&lang=ts&external"
export * from "./UserList.ts?vue&type=script&lang=ts&external"
import style0 from "./UserList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports